export default '/static/frontend/ReachDigital/12gobiking/dist/assets/visa2-8e02b985.svg'